var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C3123",
    points: "2.768 7.16 0 8.539 0 32.74 2.768 34.111 2.785 34.091 2.785 7.179 2.768 7.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#E05243",
    points: "17.503 30.599 2.751 34.111 2.751 7.16 17.503 10.596 17.503 30.599"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C3123",
    points: "10.873 25.126 17.13 25.923 17.17 25.833 17.205 15.561 17.13 15.481 10.873 16.267 10.873 25.126"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C3123",
    points: "17.105 30.632 31.47 34.111 31.492 34.075 31.492 7.184 31.469 7.16 17.105 10.635 17.105 30.632"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#E05243",
    points: "23.371 25.126 17.105 25.923 17.105 15.481 23.371 16.267 23.371 25.126"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#5E1F18",
    points: "23.404 11.984 17.138 13.127 10.873 11.984 17.13 10.343 23.404 11.984"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#F2B0A9",
    points: "23.404 29.389 17.138 28.244 10.873 29.389 17.13 31.128 23.404 29.389"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C3123",
    points: "10.873 11.967 17.121 10.42 17.172 10.405 17.172 .042 17.121 0 10.873 3.126 10.873 11.967"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#E05243",
    points: "23.371 11.967 17.105 10.42 17.105 0 23.371 3.126 23.371 11.967"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#8C3123",
    points: "17.146 41.338 10.873 38.213 10.873 29.371 17.146 30.917 17.238 31.022 17.213 41.158 17.146 41.338"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E05243",
    d: "M17.1054,41.33805 L23.37075,38.2128001 L23.37075,29.3709 L17.1054,30.9174347 L17.1054,41.33805 M31.4925,7.1604 L34.24395,8.53892898 L34.24395,32.7333556 L31.4925,34.11135 L31.4925,7.1604"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/AmazonS3.1f471043.svg";
export { ForwardRef as ReactComponent };